import React, { useEffect } from 'react';
import { useState } from '@hookstate/core';
import Typography from '@mui/material/Typography';
import { Box, Link } from '@mui/material';
import { Divider } from '@mui/material';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import EventCard from '../../components/EventCard/EventCard';
import { Downgraded } from '@hookstate/core';
import { MAX_EVENTS } from '../../constants/Constant';
import Helper from '../../utility/helper';
import { makeStyles } from '@mui/styles';
import Title from '../../sharedcomponents/title/title';
import AppConstants from '../../constants/appConstants';
import { useHistory, generatePath } from "react-router-dom";
import { setTheme } from '../../hookState/ThemeState';
import RouteConstants from '../../constants/routeConstants';

const useStyles = makeStyles({
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: '12px',
        padding: '16px',
        backgroundColor: '#fff',
        marginBottom: '32px',
        '&:last-child': {
            marginBottom: 0,
        },
        border: '1px solid #efefef',
    },
});
const titleStyle = {
    ml: 0,
    paddingBottom: '14px',
};
export default function Landing() {
    // console.log("asdinto landing");
    const history = useHistory()
    const classes = useStyles();
    const event = useState({
        current: '',
        past: '',
        upcoming: '',
    });
    // const authState = useAuthState()
    const isOpen = useState(false);
    const isOpenUp = useState(false);
    const isOpenPast = useState(false);
    const gUserInfo = Helper.getStorage('userInfo');
    const showDash = useState(false);

    const loading = useState(true);
    const getEventList = (value, eventID) => {
        ApiHelper.get(APIURLConstants.GET_EVENT_USERS(value, eventID))
            .then((res) => {
                Helper.setStorage('UserEvents', res.data);
                const current = res.data.filter(function (key) {
                    return (
                        key.status === 1 &&
                        key.readonlyOrHide !== 2
                        // &&
                        // Helper.InbetweenDate(
                        //     key.startDate,
                        //     key.endDate,
                        //     `${Helper.FormatDateOnly(new Date())}`
                        // )
                    );
                });
                // const upcoming = res.data.filter(function (key) {
                //     return (
                //         key.status === 1 &&
                //         key.readonlyOrHide !== 2 &&
                //         Helper.compareAfterDate(
                //             key.startDate,
                //             `${Helper.FormatDateOnly(new Date())}`
                //         )
                //     );
                // });
                // console.log("current",current);
                // console.log("asdasd");
                // console.log("adasd2313123",history.location.state);
                if (history.location.state === undefined && !history.location.state?.rediretDashToHome) {
                    if (current.length === 1) {
                        showDash.set(false);
                        cardRedirect(current[0])
                    }
                    else {
                        showDash.set(true);
                    }
                }
                event.set({
                    current: current,
                    // upcoming: upcoming,
                    // past: past,
                });
                // console.log("upcoming",current);
                //Helper.setStorage('upcomingEvents', upcoming)
                loading.set(false);
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    loading.set(false);
                    alert(error);
                }
            });
    };

    useEffect(() => {
        const userInfoValue = Helper.getStorage('userInfo');
        // const eventInfo = Helper.getStorage('eventInfo');

        if (userInfoValue) {
            if (userInfoValue.userType !== AppConstants.USER_TYPES[3]) {
                if (userInfoValue.userType !== AppConstants.USER_TYPES[0]) {
                    getEventList(userInfoValue.userID, 0);
                } else {
                    getEventList(0, 0);
                }
            } else {
                history.push('/chargeCard')
            }
        }

        if (history.location.state === undefined && !history.location.state?.rediretDashToHome) {
            showDash.set(false);
        }
        else if (history.location.state !== undefined && history.location.state?.rediretDashToHome) {
            showDash.set(true);
        }

    }, []);

    const cardRedirect = async (eventData) => {
        //  console.log("int card rediret");
        if (eventData) {

            if (eventData && !eventData.moduleDetails) {
                let moduleDetailResult = await ApiHelper.get(APIURLConstants.GET_EVENT_MODULE_DETAILS(eventData.eventID));
                if (moduleDetailResult) {
                    eventData.moduleDetails = moduleDetailResult.data;
                }
            }
            Helper.setStorage('eventInfo', eventData);
            // const checkAgent = gUserInfo.roles.find(
            //     (key) => key.eventRole === 'AGENT'
            // );
            let newEventData = [];
            ApiHelper.get(
                APIURLConstants.IS_AGENT(gUserInfo.userID, eventData.eventID)
            ).then((res) => {
                //newEventData.push(res.data)
                //Helper.setStorage('eventModuleConfig', res.data);
                let path = '';
                setTheme(eventData);
                Helper.setStorage('agentInfo', gUserInfo);

                if (res.data.agent) {
                    path = generatePath(RouteConstants.EVENT_AGENT_PROFILE, {
                        eventID: eventData.eventID,
                    });
                } else {
                    path = generatePath(RouteConstants.EVENT_DETAIL, {
                        eventID: eventData.eventID,
                    });
                }
                history.push({
                    pathname: path,
                    state: { event: eventData },
                });
            });

            // let path = '';
            // // console.log("eventData",eventData,"gUserInfo",gUserInfo);
            // if (eventData.agent) {
            //     Helper.setStorage('agentInfo', gUserInfo);
            //     setTheme(eventData);
            //     path = generatePath(RouteConstants.EVENT_AGENT_PROFILE, {
            //         eventID: eventData.eventID,
            //     });

            //     history.push({
            //         pathname: path,
            //         state: { event: eventData },
            //     });
            // } else {
            //     setTheme(eventData);
            //     Helper.setStorage('agentInfo', gUserInfo);
            //     ApiHelper.get(
            //         APIURLConstants.GET_AGENT_CONNECTIONS(
            //             gUserInfo.userID,
            //             eventData.eventID
            //         )
            //     ).then((res) => {
            //         // console.log("asdasdasd");              
            //         if (res.data) {
            //             let result = res.data.reduce(function (r, c) {
            //                 r[c.userID] = r[c.userID] || {
            //                     userID: c.userID,
            //                     userType: c.userType,
            //                     firstName: c.firstName,
            //                     lastName: c.lastName,
            //                     email: c.email,
            //                     picUrl: c.profilePicUrl,
            //                     roles: c.roles,
            //                     isNotification: c.isNotification,
            //                     appNotificationSetting: c.appNotificationSetting,
            //                     modules: [],
            //                     userTags: c.userTags,
            //                 };
            //                 r[c.userID].modules.push({
            //                     moduleName: c.moduleName,
            //                     statusName: c.statusName,
            //                     status: c.requestStatus,
            //                     noAccess: c.noAccess,
            //                 });

            //                 return r;
            //             }, {});

            //             let data = Object.values(result).reduce(
            //                 (r, o) => {
            //                     r[
            //                         o.userID === gUserInfo.userID
            //                             ? 'agentProfile'
            //                             : 'agentConnections'
            //                     ].push(o);
            //                     return r;
            //                 },
            //                 { agentProfile: [], agentConnections: [] }
            //             );
            //             // console.log(data);
            //             if (data &&
            //                 data.agentConnections &&
            //                 data.agentConnections.length > 0) {
            //                 path = generatePath(RouteConstants.EVENT_AGENT_PROFILE, {
            //                     eventID: eventData.eventID,
            //                 });
            //             } else {
            //                 path = generatePath(RouteConstants.EVENT_DETAIL, {
            //                     eventID: eventData.eventID,
            //                 });
            //             }
            //             history.push({
            //                 pathname: path,
            //                 state: { event: eventData },
            //             });
            //         } else {
            //             path = generatePath(RouteConstants.EVENT_DETAIL, {
            //                 eventID: eventData.eventID,
            //             });
            //             history.push({
            //                 pathname: path,
            //                 state: { event: eventData },
            //             });
            //         }
            //     })
            //         .catch((err) => {
            //             // console.log("err",err);
            //             //... Check if user's session has expired
            //             if (err.response && err.response.status === 401) {
            //                 console.log(err);
            //             }
            //         });

            // }
        }
    };

    const cardClick = () => {
        showDash.set(false);
    }
    // console.log(loading.get(),"event.get().current.length",event.current
    // .attach(Downgraded)
    // .get(), typeof event.current.attach(Downgraded).get());
    if (showDash.get()) {
        return (
            <Box
                sx={{
                    // p: 4,
                    width: '100%',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }}>
                <Box className={classes.cardContent}>
                    <Title title={'Events'} sx={titleStyle} px={0} />
                    <Box sx={{ mb: 2 }}>
                        <Divider inset="true" />
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            // justifyContent: 'evenly',
                        }}>
                        {loading.get() === true ? (
                            <>
                                <EventCard loading={loading.get()} />
                                <EventCard loading={loading.get()} />
                                <EventCard loading={loading.get()} />
                            </>
                        ) : event.get().current.length > 0 ?
                            (
                                <>
                                    {event.current
                                        .attach(Downgraded)
                                        .get()
                                        .slice(
                                            0,
                                            isOpen.value
                                                ? event.current.length
                                                : MAX_EVENTS
                                        )
                                        .map((eventList, index) => {
                                            return (
                                                <EventCard
                                                    key={`current_${index}`}
                                                    eventList={eventList}
                                                    loading={loading.get()}
                                                    onCardClick={cardClick}
                                                />
                                            );
                                        })}
                                    {event.current.length > MAX_EVENTS && (
                                        <Link
                                            component="button"
                                            variant="body2"
                                            onClick={() => {
                                                isOpen.set(!isOpen.value);
                                            }}>
                                            {isOpen.value ? 'View Less' : 'View More'}
                                        </Link>
                                    )}
                                </>
                            ) : (
                                <Typography variant="body2" noWrap>
                                    Data not found
                                </Typography>
                            )}
                    </Box>
                </Box>
                {/* <Box className={classes.cardContent}>
                <Title title={'Upcoming Events'} sx={titleStyle} px={0} />
                <Box sx={{ mb: 2 }}>
                    <Divider inset="true" />
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        // justifyContent: 'evenly',
                    }}>
                    {loading.get() === true ? (
                        <>
                            <EventCard loading={loading.get()} />
                            <EventCard loading={loading.get()} />
                            <EventCard loading={loading.get()} />
                        </>
                    ) : event.get().upcoming.length > 0 ? (
                        <>
                            {event.upcoming
                                .attach(Downgraded)
                                .get()
                                .slice(
                                    0,
                                    isOpenUp.value
                                        ? event.upcoming.length
                                        : MAX_EVENTS
                                )
                                .map((eventList, index) => {
                                    return (
                                        <EventCard
                                            key={`upcoming_${index}`}
                                            eventList={eventList}
                                            loading={loading.get()}
                                        />
                                    );
                                })}
                            {event.upcoming.length > MAX_EVENTS && (
                                <Link
                                    component="button"
                                    variant="body2"
                                    onClick={() => {
                                        isOpenUp.set(!isOpenUp.value);
                                    }}>
                                    {isOpenUp.value ? 'View Less' : 'View More'}
                                </Link>
                            )}
                        </>
                    ) : (
                        <Typography variant="body2" noWrap>
                            Data not found
                        </Typography>
                    )}
                </Box>
            </Box>
            <Box className={classes.cardContent}>
                <Title title={'Past Events'} sx={titleStyle} px={0} />
                <Box sx={{ mb: 2 }}>
                    <Divider inset="true" />
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        // justifyContent: 'evenly',
                    }}>
                    {loading.get() === true ? (
                        <>
                            <EventCard loading={loading.get()} />
                            <EventCard loading={loading.get()} />
                            <EventCard loading={loading.get()} />
                        </>
                    ) : event.get().past.length > 0 ? (
                        <>
                            {event.past
                                .attach(Downgraded)
                                .get()
                                .slice(
                                    0,
                                    isOpenPast.value
                                        ? event.past.length
                                        : MAX_EVENTS
                                )
                                .map((eventList, index) => {
                                    return (
                                        <EventCard
                                            key={`past_${index}`}
                                            eventList={eventList}
                                            loading={loading.get()}
                                        />
                                    );
                                })}
                            {event.past.length > MAX_EVENTS && (
                                <Link
                                    component="button"
                                    variant="body2"
                                    onClick={() => {
                                        isOpenPast.set(!isOpenPast.value);
                                    }}>
                                    {isOpenPast.value
                                        ? 'View Less'
                                        : 'View More'}
                                </Link>
                            )}
                        </>
                    ) : (
                        <Typography variant="body2" noWrap>
                            Data not found
                        </Typography>
                    )}
                </Box>
            </Box> */}
            </Box>
        );
    }


}
